export const USER_LOGGED_IN = 'userLogged';
export const USER_VERIFIED = 'userVerified';
export const USER_RESEND_VERIFY = 'userResendVerify';
export const USER_LOGGED_OUT = 'userLoggedOut';
export const USER_FULLNAME_UPDATE = 'userFullnameUpdate';
export const USER_PROFILE_COMPLETE = 'userProfileUpdated';

export const COMPANY_CREATED = 'companyCreated';
export const LOCATION_CREATED = 'locationCreated';